export const getCharCode = (char: string) => {
  return char.charCodeAt(0);
};
